import React, { useState, useEffect } from "react";
import { getFileUrl } from "../../Services/storage";

function ImageViewer({ imagePaths, startIndex = 0, onClose }) {
  const [idx, setIdx] = useState(startIndex);
  const [urls, setUrls] = useState(null); // null = resolving

  useEffect(() => {
    setIdx(startIndex);
  }, [startIndex]);

  useEffect(() => {
    if (!imagePaths?.length) return;
    setUrls(null);
    Promise.all(
      imagePaths.map((p) =>
        p.startsWith("http")
          ? Promise.resolve(p)
          : getFileUrl(p).then((r) => r.url).catch(() => null)
      )
    ).then((resolved) => setUrls(resolved.filter(Boolean)));
  }, [imagePaths]);

  if (!imagePaths?.length) return null;

  const resolvedCount = urls?.length ?? 0;
  const prev = () => setIdx((i) => (i - 1 + resolvedCount) % resolvedCount);
  const next = () => setIdx((i) => (i + 1) % resolvedCount);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        background: "rgba(0,0,0,0.92)",
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
      }}
    >
      {/* Close */}
      <button
        onClick={onClose}
        style={{
          position: "absolute", top: "16px", right: "16px",
          background: "rgba(255,255,255,0.12)", border: "none", borderRadius: "50%",
          width: "32px", height: "32px", cursor: "pointer",
          display: "flex", alignItems: "center", justifyContent: "center",
          color: "#fff", fontSize: "18px", lineHeight: 1,
        }}
      >
        ×
      </button>

      {urls === null ? (
        /* Loading state */
        <div style={{ fontSize: "var(--text-base)", color: "rgba(255,255,255,0.4)" }}>Loading…</div>
      ) : (
        <>
          {/* Counter */}
          {urls.length > 1 && (
            <div style={{ position: "absolute", top: "20px", left: "50%", transform: "translateX(-50%)", fontSize: "var(--text-sm)", color: "rgba(255,255,255,0.5)" }}>
              {idx + 1} / {urls.length}
            </div>
          )}

          {/* Image */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "100%", maxHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 48px" }}
          >
            <img
              src={urls[idx]}
              alt=""
              style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain", borderRadius: "4px" }}
            />
          </div>

          {/* Prev / Next */}
          {urls.length > 1 && (
            <>
              <button onClick={(e) => { e.stopPropagation(); prev(); }} style={navBtn("left")}>
                <svg viewBox="0 0 24 24" style={chevronStyle}><polyline points="15,18 9,12 15,6" /></svg>
              </button>
              <button onClick={(e) => { e.stopPropagation(); next(); }} style={navBtn("right")}>
                <svg viewBox="0 0 24 24" style={chevronStyle}><polyline points="9,18 15,12 9,6" /></svg>
              </button>
            </>
          )}
        </>
      )}
    </div>
  );
}

function navBtn(side) {
  return {
    position: "absolute", top: "50%", transform: "translateY(-50%)",
    [side]: "8px",
    background: "rgba(255,255,255,0.12)", border: "none", borderRadius: "50%",
    width: "36px", height: "36px", cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
  };
}

const chevronStyle = {
  width: "18px", height: "18px",
  stroke: "#fff", fill: "none", strokeWidth: 2,
  strokeLinecap: "round", strokeLinejoin: "round",
};

export default ImageViewer;
